import { apiRequest } from "./Api";


export const getLeadFeedbacks = (params?: {
    worker?: any,
    from_date_of_creation?: any,
    to_date_of_creation?: any,
    filter_on?: any,
    filter_source?: any,
    filter_campaign?: any
}) =>
    apiRequest<any, any>("GET", "leads/statistic/feedbacks", null, undefined, params);

export const getAppointmentFeedbacks = (params?: {
    worker?: any,
    from_date_of_creation?: any,
    to_date_of_creation?: any,
    filter_on?: any,
    filter_source?: any,
    filter_type?: any,
    filter_import_source?: any
}) =>
    apiRequest<any, any>("GET", "appointment/statistic/feedbacks", null, undefined, params);

export const getCustomerFeedbacks = (params?: {
    worker?: any,
    from_date_of_creation?: any,
    to_date_of_creation?: any,
    filter_on?: any,
    product?: any,
    company?: any
}) =>
    apiRequest<any, any>("GET", "costumers/statistic/product-feedbacks", null, undefined, params);

export const getLeaderboard = (params?: {
    from_date_of_creation?: any,
    to_date_of_creation?: any,
    filter_on?: any,
    type_of_statistic?: any
}) =>
    apiRequest<any, any>("GET", "global-statistic/top-users-by-performance", null, undefined, params);


export const getGeneralStats = (params?: {
    from_date_of_creation?: any,
    to_date_of_creation?: any,
    filter_on?: any,
}) =>
    apiRequest<any, any>("GET", "global-statistic/general", null, undefined, params);

export const getTodayTomorrowAppointments = () =>
    apiRequest<any, any>("GET", "appointment/statistic/today-tomorrow-appointments", null, undefined, undefined);

export const getCounterTool = (params?: {
    from_date_of_creation?: any,
    to_date_of_creation?: any,
    filter_on?: any,
    insurance_company?: any,
    source: any
}) =>
    apiRequest<any, any>("GET", "global-statistic/counter-tool", null, undefined, params);


